export enum LocalLocationType {
  CHEP    = 'CHEP',
  CUST    = 'CUST',
  UNKNOWN = 'UNKNOWN'
}
